import React from 'react';
import PageHeaderText from 'components/base/page-header-text';
import MealCategoryListPage from './meal-category-list-page';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const MealIndex = () => {
  const { permissions } = useDashboardContext();
  const canAccessMeals = permissions.canAccessMeals;
  if (!canAccessMeals) return <AccessDenied />;
  return (
    <div>
      <PageHeaderText
        title='Manage meals'
        description='Manage meal categories for each brand on the Foodcourt app'
      />
      <MealCategoryListPage />
    </div>
  );
};

export default MealIndex;
